import proj4 from 'proj4'
import { register } from 'ol/proj/proj4'
import { get as getProjection, setUserProjection } from 'ol/proj'
import { getWidth } from 'ol/extent'
import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root',
})
export class OpenLayersProjectionService {

    readonly EPSG5514: {code; projection; resolutions; matrixIds; boundaries} = this.setProjectionEPSG5514()

    private setProjectionEPSG5514(): any {

        const code = 'EPSG:5514'
        const boundaries = [-925000, -1244353.5359999998, -400646.46400000004, -920000]

        proj4.defs(code, '+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=570.8,85.7,462.8,4.998,1.587,5.261,3.56 +units=m +no_defs')
        register(proj4)

        const projection = getProjection(code)
        projection.setExtent(boundaries)

        setUserProjection(code)

        const size = getWidth(projection.getExtent()) / 256
        const matrixLevels = 22
        const resolutions = new Array(matrixLevels)
        const matrixIds = new Array(matrixLevels)
        for (let z = 0; z < matrixLevels; z += 1) {
            resolutions[z] = size / 2 ** z
            matrixIds[z] = z
        }

        return {
            code,
            projection,
            resolutions,
            matrixIds,
            boundaries,
        }
    }
}